import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit
} from '@angular/core';
import * as c3 from 'c3';
import { GraphUtilsService } from '../../services/graph-utils.service';
import { DataService } from '../../services/data.service';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'app-c3-summary-chart',
    templateUrl: './c3-summary-chart.component.html',
    styleUrls: ['./c3-summary-chart.component.scss'],
    standalone: false
})
export class C3SummaryChartComponent implements OnChanges, AfterViewInit, OnDestroy {

  @Input() data: any;
  @Input() paramNameList: any;
  @Input() inclindXaxis = 0;

  trendChart: any = null;
  subscriptions: any;
  constructor(
    private graphUtil: GraphUtilsService,
    private elRef: ElementRef,
    private dataServ: DataService, private utilsService: UtilsService
  ) {

    this.subscriptions = dataServ.events.subscribe(this.replotGraphEventSubscription);
  }

  replotGraphEventSubscription = (res: any) => {
    if (res.name === 'replotGraph') {
      let timeoutval = 0;
      if (res.args && res.args[0] === 'menuToggle') {
        timeoutval = 101;
      }
      setTimeout(() => {
        this.checkAndReplotTrendGraph();
      }, timeoutval);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.checkAndReplotTrendGraph();
  }

  ngAfterViewInit(): void {
    this.checkAndReplotTrendGraph();
  }

  checkAndReplotTrendGraph() {
    if (this.data && this.data.length) {
      this.generateChart(this.data);
    }
  }

  setLegendLabel(ind) {
    /* istanbul ignore if */
    if (this.paramNameList.length - 1 >= ind) {
      return this.paramNameList[ind].parametername;
    }
    return null;
  }

  generateChart = (data) => {
    let xsData = {};
    var colDatax = [];
    var colDatay = [];
    let paramName = {};
    let i = 0;
    data.forEach((e, j) => {
      /* istanbul ignore if */
      if (e.timeSeriesData && e.timeSeriesData.length) {
        xsData['data' + [i]] = 'x' + [i];
        paramName['data' + [i]] = this.setLegendLabel(j);
        colDatax[i] = ['x' + (i), ...e.timeSeriesData.map(elem => elem.convertedTS)];
        colDatay[i] = ['data' + (i), ...e.timeSeriesData.map(elem => elem.value)];
        i = i + 1;
      }
    });

    // const range = this.data1.map(elem => elem.value).concat(this.data2.map(elem => elem.value), this.data3.map(elem => elem.value),
    //   this.data4.map(elem => elem.value), this.data5.map(elem => elem.value), this.data6.map(elem => elem.value))
    this.trendChart = c3.generate({
      bindto: this.elRef.nativeElement.children[0].children[0],
      legend: {
        show: true
      },
      padding: {
        right: 25,
      },
      data: {
        xs: xsData,
        columns: colDatax.concat(colDatay),
        type: 'line',
        names: paramName
      },
      transition: {
        duration: 0
      },
      point: {
        r: 3
      },
      axis: {
        x: {
          type: 'timeseries',
          tick: {
            count: this.data && this.data.length ? (this.data.length < 10 ? 10 : this.data.length) : 10,
            // format: '%_d %b %y %H:%M',
            multiline: true,
            rotate: this.inclindXaxis,
            format: (x: any) => {
              if (!x || x.toString() === 'Invalid Date' || isNaN(x)) {
                return '';
              }
              const str = x ? this.utilsService.formatDateDDMonYYHHMM(x) : '';
              return str;
            }
          },
        },
        // y: {
        //   max: Math.floor(Math.max(...range))
        // }
      },
      zoom: {
        type: 'scroll',
        enabled: true
      },
      grid: {
        lines: {
          front: false
        }
      },
      color: {
        pattern: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d1d407', '#da7698', '#798998']
      },
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
